import { Component } from "react"

/* Circular countdown ring */
import { CountdownCircleTimer } from "react-countdown-circle-timer"

/* Status */
import { CHOICE, INSURANCE, EVENMONEY, GAME } from "../constants/status"


/*
    UvpTimer — adapted from uvp-front. The number in the centre always comes
    straight from the backend "timer" tick (source of truth, pause-safe); the
    ring is a decorative indicator whose span is the phase duration.

    Phase durations MUST match mob-back Play.js:
      betting (CHOICE)    -> BET_TIME       = 1500
      insurance           -> INSURANCE_TIME = 12
      decision (GAME)     -> DECISION_TIME  = 15
*/
const DURATION = { [CHOICE]: 15, [INSURANCE]: 12, [EVENMONEY]: 12, [GAME]: 10 }

class UvpTimer extends Component {

    render = () => {

        const { status, timer } = this.props

        const timed = status === CHOICE || status === INSURANCE || status === EVENMONEY || status === GAME
        if (!timed || !timer || timer <= 0) return null

        const duration = DURATION[status] || timer
        const style = timer < 6 ? "animated" : ""

        return (
            <div className="timer">
                <CountdownCircleTimer
                    isPlaying={true}
                    size={120}
                    strokeWidth={15}
                    colors={["#448b03", "#dba504", "#a20101"]}
                    colorsTime={[duration * 0.7, duration * 0.4, duration * 0.01]}
                    duration={duration}
                    key={`${status}-${duration}`}
                    trailColor="rgba(255, 255, 255, 0.2)"
                    initialRemainingTime={timer}
                >
                    {() => <span className={`timer-text ${style}`}>{timer}</span>}
                </CountdownCircleTimer>
            </div>
        )
    }
}

export default UvpTimer
